module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/cobrand-retailmenot-promo-f3133995ab5595df5c2d6da75380415e.jpg";